import { useContext } from "react";
import { ThemeContext } from "../global";
import TopBar from "../components/topbar/TopBar";

export const NotFound = () => {
  const { myTheme } = useContext(ThemeContext);
  return (
    <div>
      <TopBar navigateTo={"/"} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: `${myTheme.colors.title}`,
          height: "100vh",
          width: "100vw",
        }}
      >
        <h1>404 Page not found.</h1>
      </div>
    </div>
  );
};
